module.exports = __webpack_public_path__ + "img/1440.4fb1cb61.jpg";